import {
  Html5Outlined,
  CodeOutlined,
  NodeIndexOutlined,
  ApiOutlined,
  DatabaseOutlined,
  FireOutlined,
  BorderOutlined,
  BgColorsOutlined,
  GlobalOutlined,
  MobileOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  SyncOutlined,
  GithubFilled,
} from "@ant-design/icons";
import me from "./assets/images/me.jpeg";

import e1 from "./assets/screenshots/desktop_apps/e1.png";
import match from "./assets/screenshots/desktop_apps/match.png";
import q1 from "./assets/screenshots/desktop_apps/q1.png";
import q2 from "./assets/screenshots/desktop_apps/q2.png";
import q3 from "./assets/screenshots/desktop_apps/q3.png";
import q4 from "./assets/screenshots/desktop_apps/q4.png";
import q5 from "./assets/screenshots/desktop_apps/q5.png";
import love from "./assets/images/love.png";
import Store from "./assets/images/7store.png";
import flashinsky from "./assets/images/flashinsky.png";
import event from "./assets/videos/event.mp4";
import zakat from "./assets/videos/zakat.mp4";
import lead from "./assets/images/leadforge.png";
import win4lux from "./assets/screenshots/wiforLux/win4lux.png";
import mobicrypto from "./assets/screenshots/mob/mobicrypto.png";
import timepulse from "./assets/screenshots/timepulse/timepulse.png";
const logotext = "NTD";
const meta = {
  title: "Nouman The Developer",
  description:
    "As a skilled MERN stack developer, I excel in creating robust and scalable web applications alongwith android React Native Apps, with expertise extending to front-end development with Bootstrap, Tailwind CSS, Saas, and Scss, back-end development with Node.js, Express, and MongoDB, and real-time database management with Google Firebase and Firestore.",
};

const introdata = {
  name: "Nouman",
  title: "I'm Nouman",
  animated: {
    first: "Web developer",
    second: "Android App developer",
    third: "Desktop App developer",
  },
  description:
    "As a skilled MERN stack developer, I excel in creating robust and scalable web applications alongwith android React Native Apps.",
  your_img_url: me,
};

const dataabout = {
  title: "who am I",
  aboutme:
    "As a skilled MERN stack developer, I excel in creating robust and scalable web applications alongwith android React Native Apps, with expertise extending to front-end development with Bootstrap, Tailwind CSS, Saas, and Scss, back-end development with Node.js, Express, and MongoDB, and real-time database management with Google Firebase and Firestore.",
};
const worktimeline = [
  {
    jobtitle: "Designer of week",
    where: "YAdfi",
    date: "2020",
  },
  {
    jobtitle: "Designer of week",
    where: "Jamalya",
    date: "2019",
  },
  {
    jobtitle: "Designer of week",
    where: "ALquds",
    date: "2019",
  },
];

const skills = [
  {
    name: "HTML / CSS + Javascript ES6",
    value: 90,
    icon: <Html5Outlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "MUI / Bootstrap / Tailwind / SCSS",
    value: 85,
    icon: <BorderOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "React and React Native",
    value: 85,
    icon: <CodeOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "Node.js",
    value: 80,
    icon: (
      <NodeIndexOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />
    ),
  },
  {
    name: "Express",
    value: 75,
    icon: <ApiOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "MongoDB",
    value: 85,
    icon: <DatabaseOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "Firebase",
    value: 80,
    icon: <FireOutlined style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
  {
    name: "Git and GitHub",
    value: 80,
    icon: <GithubFilled style={{ fontSize: "2rem", color: "#ffffffff" }} />,
  },
];

const services = [
  {
    title: "Custom Website Development",
    description:
      "I specialize in building responsive and scalable websites for various industries, including e-commerce, blogs, and business solutions.",
    icon: <GlobalOutlined />,
  },
  {
    title: "Mobile App Development",
    description:
      "I develop robust and user-friendly mobile applications using React Native for Android, tailored to meet your business needs.",
    icon: <MobileOutlined />,
  },
  {
    title: "CMS-Based Website Development",
    description:
      "I create dynamic websites with CMS integration, for seamless content management and customization.",
    icon: <SettingOutlined />,
  },
  {
    title: "E-Commerce Solutions",
    description:
      "I develop secure and feature-rich e-commerce platforms with payment gateway integration and custom functionalities.",
    icon: <ShoppingCartOutlined />,
  },
  {
    title: "Backend Development",
    description:
      "I build powerful and scalable backend systems using Node.js, Express, and MongoDB, ensuring optimal performance and security.",
    icon: <DatabaseOutlined />,
  },
  {
    title: "Real-Time Database Integration",
    description:
      "I implement real-time database solutions using Firebase and Firestore for applications requiring live data synchronization.",
    icon: <SyncOutlined />,
  },
];
const dataportfolio = [
  {
    title: "TimePulse - (Web & Desktop)",
    description:
      "A full-featured productivity tracking system inspired by Hubstaff, including desktop app and web dashboard with time tracking, screenshot capturing, activity monitoring, and user management.",
    img: timepulse,
    techStack: ["React", "Electron.js", "Node.js", "MongoDB", "Express", "MUI"],
    previewLink: "https://trackhives.netlify.app/auth/login",
    category: "websites",
    status: "completed",
  },
  {
    title: "win4lux",
    description:
      "This was one of my major projects having about 57 functional pages , admin and user panel Multi-level marketing website with level-wise commission tracking, tree graph visualizations, and detailed reports. Includes complete user profile management: 2FA, password reset/change, etc.",
    img: win4lux,
    techStack: [
      "React",
      "Node.js",
      "MongoDB",
      "paypal",
      "nowpayments",
      "MUI",
      "Tailwind",
    ],
    previewLink: "https://win4lux.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "MobiCrypto",
    description:
      "A unilevel and Binary Crypto mining website, where user can earn different tpes of commission and coinpayments integrated",
    img: mobicrypto,
    techStack: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "mui",
      "coinpayments",
    ],
    previewLink: "https://n-mobicrypto.netlify.app/auth/login",
    category: "websites",
    status: "completed",
  },
  {
    title: "Unified Voter",
    description:
      "An advanced platform built during internship to manage elections digitally, featuring candidate/voter management, secure authentication, and real-time voting results.",
    img: "https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?w=800&h=600&fit=crop",
    techStack: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "JWT",
      "MUI",
      "Firebase",
    ],
    previewLink: "https://unifiedvoter.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "LeadForge",
    description:
      "An advanced platform built with PERN stack to manage leads and customers digitally, featuring lead/customer management, and BULK email management with tracking and cutom tones",
    img: lead,
    techStack: [
      "React",
      "Node.js",
      "Express",
      "PostgreSQL",
      "Ant Design",
      "nodemailer",
    ],
    previewLink: "https://leadforge-n.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Flashinsky",
    description:
      "A platform where admin add different types of content like any helpfull file or material and users can purchase a subscription to browse the material.",
    img: flashinsky,
    techStack: ["React", "Node.js", "Express", "Mongo DB", "MUI"],
    previewLink: "https://flashinsky.netlify.app/",
    category: "websites",
    status: "in-progress",
  },
  {
    title: "7 Store",
    description:
      "An ecommerce platform where mlm integrated, user and admin panel where product, order and user management, kind a like POS billing system, stock management with user and admin dashboards.",
    img: Store,
    techStack: ["React", "Node.js", "Express", "Mongo DB", "MUI"],
    previewLink: "https://7store.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Foodify",
    description:
      "An e-commerce platform for restaurant services, featuring menu Browse, online ordering.",
    img: "https://noumanthedeveloper1.web.app/static/media/foodify.531d2a6f412bea727e76.png",
    techStack: ["React", "Node.js", "Firebase"],
    previewLink: "https://nn-lms.web.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Love Beauty and planet",
    description:
      "A modern e-commerce platform for fashion stores, offering a seamless shopping experience.",
    img: love,
    techStack: ["React", "Firebase", "ant", "+ many other open source"],
    previewLink: "https://fashion-planet.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Full-Stack OLX Clone",
    description:
      "A fully functional OLX clone with user authentication, ad posting, and real-time features.",
    img: "https://upload.wikimedia.org/wikipedia/commons/b/b3/Logo_olx.png",
    techStack: ["React", "Node.js", "Express", "MongoDB", "Firebase"],
    previewLink: "https://fashion-store-1083e.web.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "OLMS (Online Learning Management System)",
    description:
      "A learning management system for online courses, with features like user registration, course tracking, and it has MULTI ROLE BASED authentication.",
    img: "https://noumanthedeveloper1.web.app/static/media/olms.38ba1b781c37664ca6d2.png",
    techStack: ["React", "Firebase", "ant", "+ many other open source"],
    previewLink: "https://n-olms.netlify.app/",
    category: "websites",
    status: "completed",
  },

  {
    title: "Fashion Store",
    description:
      "A modern e-commerce platform for fashion stores, offering a seamless shopping experience.",
    img: "https://noumanthedeveloper1.web.app/static/media/fashion.d97280617dfabd3d770d.png",
    techStack: ["React", "Firebase", "ant", "+ many other open source"],
    previewLink: "https://fashion-store47.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Shopity",
    description:
      "An electronics e-commerce platform with advanced search, product filters,checkout and order tracking and management",
    img: "https://noumanthedeveloper1.web.app/static/media/shopity.8136ed06103ace7caa7e.png",
    techStack: ["React", "Firebase", "ant", "+ many other open source"],
    previewLink: "https://shopity47.netlify.app/",
    category: "websites",
    status: "completed",
  },
  {
    title: "Math Quiz game",
    description:
      "A a game to test your mental activeness with 3 different levels asks math questions gives result and score evaluation.",
    img: "https://media.istockphoto.com/id/1488144839/vector/quiz-logo-quiz-time-label-with-question-mark-quiz-emblem-for-business-marketing-and.jpg?s=612x612&w=0&k=20&c=eYgHRl9M7FtpLRCS-ZKABj3IU5E62cgGUTCY2HN5JO8=",
    techStack: ["Electron.js"],
    previewLink: "https://system-monitor-pro.com",
    category: "desktop",
    status: "completed",
    images: [q1, q2, q3, q4, q5], // Example images for desktop
  },
  {
    title: "TimePulse - offline synchronization",
    description:
      "An app made in MERN , tracks actvity takes screenshot and tracks apps and opened urls send and synchronize data to server crash secure an reports",
    img: timepulse,
    techStack: ["Electron.js"],
    previewLink: "https://system-monitor-pro.com",
    category: "desktop",
    status: "completed",
    previewLink:
      "https://www.dropbox.com/scl/fi/c4qofc330txu4igmii5m2/timepulse.rar?rlkey=hp3fvijevokqcjkaf746x8dr0&st=xzdk4bqu&dl=1",
    // images: [
    //   "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    // ], // Example images for desktop
  },
  {
    title: "Photo editing app",
    description:
      "A photo editing apps that performs some basic editing options",
    img: "https://static.vecteezy.com/system/resources/previews/010/952/951/non_2x/movie-film-editor-logo-design-video-editing-logo-concept-vector.jpg",
    techStack: ["Electron.js"],
    category: "desktop",
    status: "completed",
    images: [e1], // Example images for desktop
  },
  {
    title: "Matching Card Game",
    description: "A fun card matching game score and time monitor",
    img: "https://s3images.coroflot.com/user_files/individual_files/133904_AhWF7O5sfiUu5C4BO3PnvdPpw.png",
    techStack: ["Electron.js"],
    category: "desktop",
    status: "completed",
    images: [match], // Example images for desktop
  },

  {
    title: "Zakat App",
    description:
      "A mobile app designed to calculate and track Zakat payments efficiently. Currently working on it.",
    img: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=600&fit=crop",
    techStack: ["React Native", "Firebase", "Node.js", "MongoDB"],
    previewLink: "#",
    category: "mobile",
    status: "in-progress",
    video: zakat, // Example video URL
  },
  {
    title: "Event Planner",
    description:
      "An intuitive app for planning and managing events with real-time updates and reminders.",
    img: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&h=600&fit=crop",
    techStack: ["React Native", "Firebase", "Node.js", "MongoDB"],
    previewLink: "#",
    category: "mobile",
    status: "completed",
    video: event, // Example video URL
  },
  {
    title: "Shopity 2.0 Mobile Version",
    description:
      "A mobile version of the Shopity e-commerce platform, providing seamless shopping experiences on the go.",
    img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop",
    techStack: ["React Native", "Redux", "Node.js", "MongoDB", "Stripe"],
    previewLink: "#",
    category: "mobile",
    status: "completed",
    video: "https://www.youtube.com/embed/your-shopity-video-id", // Example video URL
  },
];

const contactConfig = {
  YOUR_EMAIL: "mnoumankhalid195@gmail.com",
  YOUR_FONE: "+92 3028954240",
  description: "Their is nothing that cant be coded...",
  YOUR_SERVICE_ID: "service_0s90awq",
  YOUR_TEMPLATE_ID: "template_cn59utt",
  YOUR_USER_ID: "rEKXgYF9lRwbtOO91",
};

const socialprofils = {
  github: "https://github.com/Nouman475",
  linkedin: "https://linkedin.com/noumanthedeveloper",
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
